export const AuditEmailsConstant = {
    API: 'AuditEmail'
}

export const AuditEmailsAPIConstant = {
    GET_AUDIT_EMAILS: AuditEmailsConstant.API + '/GetAuditEmails',
    GET_AUDIT_EMAIL_USERS: AuditEmailsConstant.API + '/GetAuditEmailUsers',
    GET_MATERIA_NAME: AuditEmailsConstant.API + '/GetMaterialName',
    GET_AUDIT_EMAILS_FOR_EXCEL: AuditEmailsConstant.API + '/GetAuditEmailsForExcel'
} 